import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';
import isApiSuccess from '../RestClient/isApiSuccess';
import getOfferingFallBack from './getOfferingFallBack';

/**
 * Function to fetch all product pricing.
 */
export const getPriceByUrl = (payload, virtualAPI) => { //eslint-disable-line
    const context = RestClient.getContext();
    const config = {
        excludeVersion: true,
        apiHost: apiHosts.browse,
        credentials: 'include',
        virtual: virtualAPI,
        url: payload.url,
        params: payload.params,
        hostname: context && context.hostname,
        XForwardedChannelHeader: `${payload.deviceSize}`,
        jcpHeader: payload.promiseAPI,
    };
    config.customHeaders = {};
    /* istanbul ignore if */
    if (payload.promiseAPI) {
        config.customHeaders = {
            'X-Client-Name': 'PDPREGULAR',
        };
    }
    if (payload.xClientSource) {
        config.customHeaders['x-client-source'] = payload.xClientSource;
    }
    /* istanbul ignore next */
    return RestClient.get(config)
        .then(({ data, status }) => (isApiSuccess(status) && data) || getOfferingFallBack())
        .catch((error) => {
            console.log(`request failed ${error}`);
        });
};
